<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('payOvertimeRuleByShift.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form>
          <div class="ts-flex ts--mx-2">
            <div class="ts-w-1/3 px-2">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label class="col-form-label control-label required">{{
                      $t('payOvertimeRuleByShift.shiftName')
                    }}</label>
                    <div>
                      <ts-select
                        v-model="shiftNo"
                        :options="
                          shiftWorkingHours.map(e => ({
                            text: e.shift_name,
                            value: e.record_id
                          }))
                        "
                        :class="{ 'is-invalid': errors.has('shift_id') }"
                      />
                      <!-- <ts-input :value="editData.shift.shift_name" disabled /> -->
                      <div class="invalid-feedback" v-if="errors.has('shift_id')">{{ errors.first('shift_id') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ts-w-1/3 px-2">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label
                      class="col-form-label control-label"
                      :class="{ required: shiftType(shiftNo) == 'Rotation' }"
                      >{{ $t('payOvertimeRuleByShift.keyword') }}</label
                    >
                    <div>
                      <ts-input :value="model.keyword" :class="{ 'is-invalid': errors.has('keyword') }" disabled />
                      <div class="invalid-feedback" v-if="errors.has('keyword')">{{ errors.first('keyword') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ts-w-1/3 px-2">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label class="col-form-label control-label required">{{
                      $t('payOvertimeRuleByShift.otName')
                    }}</label>
                    <div>
                      <ts-select
                        v-model="model.ot_id"
                        :options="
                          overtimeItems.map(e => ({
                            text: e.ot_name,
                            value: e.ot_id
                          }))
                        "
                        :class="{ 'is-invalid': errors.has('ot_id') }"
                      />
                      <div class="invalid-feedback" v-if="errors.has('ot_id')">{{ errors.first('ot_id') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ts-flex ts--mx-2">
            <div class="ts-w-1/2 px-2">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label class="col-form-label control-label">{{ $t('payOvertimeRuleByShift.dayFrom') }}</label>
                    <div>
                      <ts-input :value="dayFrom(model.day_id_from)" disabled />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label class="col-form-label control-label">{{ $t('payOvertimeRuleByShift.dayTo') }}</label>
                    <div>
                      <ts-input :value="dayTo(model.day_id_to)" disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ts-w-1/2 px-2">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label class="col-form-label control-label required">{{
                      $t('payOvertimeRuleByShift.timeFrom')
                    }}</label>
                    <div>
                      <ts-time-picker-input v-model="model.time_from" :use24Hour="true" />
                      <div class="invalid-feedback" v-if="errors.has('time_from')">{{ errors.first('time_from') }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label class="col-form-label control-label required">{{
                      $t('payOvertimeRuleByShift.timeTo')
                    }}</label>
                    <div>
                      <ts-time-picker-input v-model="model.time_to" :use24Hour="true" />
                      <div class="invalid-feedback" v-if="errors.has('time_to')">{{ errors.first('time_to') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label">{{ $t('payOvertimeRuleByShift.remarks') }}</label>
                <div>
                  <ts-textarea v-model="model.remarks" rows="3" />
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 ts-text-right">
              <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
              <ts-button
                outline
                color="primary"
                class="ml-2"
                :waiting="savingAndNew"
                @click.prevent="saveAndNew"
                v-if="editData === undefined"
                >{{ $t('button.createAndNew') }}</ts-button
              >
              <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">
                {{ editData ? $t('button.update') : $t('button.create') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'pay-overtime-rule-by-shift-form',
  props: ['editData'],
  data() {
    const model = {
      shiftNo: this.editData ? this.editData.record_id : '',
      record_id: this.editData ? this.editData.record_id : '',
      shift_id: this.editData ? this.editData.shift_id : '',
      ot_id: this.editData ? this.editData.ot_id : '',
      time_from: this.editData ? this.editData.time_from : '',
      time_to: this.editData ? this.editData.time_to : '',
      remarks: this.editData ? this.editData.remarks : ''
    }

    return {
      shiftNo: '',
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false,
      loadingPreData: false
    }
  },
  computed: {
    ...mapState('hr/payOvertimeRuleByShift', ['shiftWorkingHours', 'overtimeItems']),
    ...mapGetters('hr/payOvertimeRuleByShift', ['dayFrom', 'dayTo', 'shiftType'])
  },
  async created() {
    this.loadingPreData = true

    await Promise.all([this.fetchShiftWorkingHours(), this.fetchOvertimeItems()]).then(responses => {
      this.loadingPreData = false

      const workingHour = this.shiftWorkingHours.find(s => {
        // return s.shift_id ==
      })
    }),
      this.setEdit()
  },
  methods: {
    ...mapActions('hr/payOvertimeRuleByShift', ['fetchShiftWorkingHours', 'fetchOvertimeItems']),
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/payOvertimeRuleByShift/update', {
          id: this.editData.id,
          shift_type: this.shiftType(this.shiftNo),
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/payOvertimeRuleByShift/create', {
          shift_type: this.shiftType(this.shiftNo),
          ...this.model
        })
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/payOvertimeRuleByShift/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          if (error.errors) this.errors = new Errors(error.errors)
          else this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
          this.shiftNo = ''
        })
        .finally(() => {
          this.savingAndNew = false
        })
    },
    setEdit() {
      this.shiftNo = this.editData ? this.editData.record_id : ''
    }
  },
  watch: {
    shiftNo: function(shiftNo) {
      console.log()
      const workingHour = this.shiftWorkingHours.find(s => s.record_id == shiftNo)

      if (workingHour) {
        this.model.record_id = workingHour.record_id
        this.model.shift_id = workingHour.shift_id
        this.model.keyword = workingHour.keyword
        this.model.day_id_from = workingHour.day_id_from
        this.model.day_id_to = workingHour.day_id_to
      }
    }
  }
}
</script>
